import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  container: {
    marginTop: '16px !important',
    marginBottom: '16px !important',
    display: 'flex',
  },
  inputLabel: {
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  radiusSelect: {
    height: '40px',
    marginBottom: theme.spacing(1),
  },
  searchInput: {
    '& fieldset': {
      borderRadius: '4px',
    },
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginRight: theme.spacing(2),
  },
  mobileSecNavContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  mobileSecNavIcons: {
    color: theme.palette.secondary.main,
    width: '60%',
    height: '60%',
    maxWidth: '45px',
    maxHeight: '45px',
  },
  mobileSecNavBtn: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0px 0px',
  },
  dropdownRoot: {
    zIndex: theme.zIndex.tooltip,
    top: '16px !important',
  },
  locationSearchResultButton: {
    display: 'flex',
    width: '100%',
    justifyContent: 'start',
    textAlign: 'left',
    textTransform: 'none',
    fontWeight: '400',
    fontSize: '16px',
    '&:focus': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  locationSearchResultButtonActive: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    outline: 'solid',
  },
  locationSearchResultIcon: {
    fontSize: '32px',
    background: '#eee',
    borderRadius: '16px',
    padding: '2px',
  },
}))
